import { Signpost, LayoutGrid, Store, Columns, Armchair, Scissors, Factory, Award } from "lucide-react";
import { PHOTOS } from "@/lib/site";

const applications = [
  { icon: Signpost, title: "Signage & Huruf Timbul", desc: "Branding indoor dan outdoor dengan tampilan tajam." },
  { icon: LayoutGrid, title: "Display Produk", desc: "Etalase produk premium dengan kejernihan maksimal." },
  { icon: Store, title: "Rak & Etalase", desc: "Konstruksi rapi untuk retail dan showroom." },
  { icon: Columns, title: "Partisi & Interior", desc: "Sekat ruangan modern yang tetap terlihat lapang." },
  { icon: Armchair, title: "Furniture & Dekorasi", desc: "Aksen premium untuk mebel dan interior desainer." },
  { icon: Scissors, title: "Laser Cutting & CNC", desc: "Presisi tinggi untuk kebutuhan fabrikasi." },
  { icon: Factory, title: "Kebutuhan Industri", desc: "Aplikasi manufaktur, pelindung mesin, dan panel teknis." },
  { icon: Award, title: "Plakat & Panel Dekoratif", desc: "Plakat penghargaan dan panel dekorasi dari acrylic." },
];

const galleryImages = [PHOTOS.produkSignage, PHOTOS.produkEmblem];

export const Applications = () => {
  return (
    <section id="aplikasi" data-testid="applications-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <div className="tag-uppercase text-animax-orange mb-4">Ruang Aplikasi</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
            Aplikasi material untuk berbagai kebutuhan proyek
          </h2>
          <p className="mt-4 text-neutral-600 text-lg leading-relaxed">
            Dari signage, display, interior, hingga kebutuhan industri, PT APL membantu pelanggan
            memilih material yang sesuai dengan fungsi, tampilan, dan skala proyek.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-4 auto-rows-[180px]">
          <div className="col-span-12 md:col-span-8 row-span-2 rounded-2xl overflow-hidden relative group" data-testid="app-hero-1">
            <img src={galleryImages[0]} alt="Signage" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-animax-black/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="tag-uppercase text-animax-yellow mb-2">Hasil Produk Kami</div>
              <div className="font-display text-2xl md:text-3xl text-white font-medium">Signage & Display Modern</div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 row-span-2 rounded-2xl overflow-hidden relative group" data-testid="app-hero-2">
            <img src={galleryImages[1]} alt="Interior" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-animax-black/80 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="tag-uppercase text-animax-yellow mb-2">Hasil Produk Kami</div>
              <div className="font-display text-xl text-white font-medium">Panel & Dekorasi Interior</div>
            </div>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
          {applications.map((a, i) => (
            <div
              key={i}
              data-testid={`app-item-${i}`}
              className="card-lift group p-6 rounded-2xl border border-neutral-200 bg-white hover:border-animax-orange"
            >
              <div className="w-10 h-10 rounded-lg bg-animax-yellow/10 flex items-center justify-center mb-4 group-hover:bg-animax-yellow transition-colors">
                <a.icon className="w-5 h-5 text-animax-orange group-hover:text-animax-black" />
              </div>
              <h4 className="font-display text-base font-medium text-animax-black">{a.title}</h4>
              <p className="mt-2 text-xs text-neutral-600 leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
